import {colors, fontSize, sizes} from "patient-ping-remedy/packages/theme";
import styled from '@emotion/styled';
import Badge from "patient-ping-remedy/packages/badge";
import {StandardTypography} from "patient-ping-remedy/packages/typography";

export const RiskFlagsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: ${sizes.xxSmall};
`;

export const RiskFlagsBadge = styled(Badge)<{ hasNoName: boolean }>`
  display: ${({ hasNoName }) => 
    (hasNoName ? 'block' : 'inline-block')};
  color: ${colors.primary1};
  border-radius: ${sizes.small};
`;

export const StyledStandardTypography = styled(StandardTypography)`
  font-size: ${fontSize.standard};
  background-color: ${(colors.gray5)};
  padding: ${sizes.xxSmall};
  border-radius: ${sizes.xxSmall};
  color: ${({color}): string => (color ? color : colors.white)};
`;
